<ew-mat-dialog-custom>
  <ew-mat-stepper-custom>
    <ew-mat-stepper-custom-step>
      <h1 class="mb-3">Select the provider to pay</h1>

      <mat-radio-group class="gap-2 grid mt-2" [(ngModel)]="provider">
        <mat-radio-button
          class="border-custom-primary"
          color="primary"
          [value]="item"
          *ngFor="let item of providers">
          <div class="flex items-center gap-3">
            <img
              class="w-10 h-10 object-scale-down"
              [src]="item.company.img"
              alt="" />
            <div class="font-medium">{{ item.company.name }}</div>
          </div>

          <div class="font-bold">
            {{ item.amount }}
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </ew-mat-stepper-custom-step>

    <!-- <ew-mat-stepper-custom-step>
          <div class="gt-xs:flex justify-between">
            <div>
              <h1 class="mb-2">Select the booking to pay</h1>
              <div>You can select multiple students</div>
            </div>
            <div class="flex gap-3 items-center" *ngIf="provider">
              <div>
                <h1 class="mb-2">Provider</h1>
                <div>{{provider.company.name}}</div>
              </div>
              <img class="w-10 h-10 object-scale-down" [src]="provider.company.img" alt="">
            </div>
          </div>

          <mat-radio-group class="gap-2 grid mt-2" *ngFor="let item of bookings">
            <mat-radio-button class="border-custom-primary xs-block" color="primary" [value]="item">
              <div class="xs:border-b">
                <div class="">Student Name</div>
                <div class="font-bold gt-xs:text-lg">{{item.student}}</div>
              </div>

              <div class="xs:border-b">
                <div class="">Booking Reference</div>
                <div class="font-bold gt-xs:text-lg">{{item.id}}</div>
              </div>

              <div class="text-warn">
                <div class="">-220,000.00 MXN</div>
                <div class="font-bold gt-xs:text-lg">{{item.price}}</div>
              </div>
            </mat-radio-button>
          </mat-radio-group>

          <div class="text-center p-5">
            <div class="">Balance to pay:</div>
            <div class="text-warn font-bold text-lg">-$15,074.00 CAD</div>
          </div>
        </ew-mat-stepper-custom-step> -->

    <ew-mat-stepper-custom-step>
      <div class="flex flex-col">
        <div class="gt-xs:flex justify-between">
          <div class="">
            <h1 class="mb-3">Select the amout to transfer</h1>
          </div>

          <ew-select-currency
            [label]="'Payment currency:'"></ew-select-currency>
        </div>

        <div class="gt-xs:px-14 xl:p-20">
          <ew-price-information [price]="315074.15"></ew-price-information>
        </div>

        <div class="text-center p-5">
          <div class="">Balance to pay:</div>
          <div class="text-warn font-medium text-lg">-$0 MXN -$0 CAD</div>
        </div>
      </div>
    </ew-mat-stepper-custom-step>

    <!-- <ew-mat-stepper-custom-step>
          <h1 class="mb-3">Select your prefered payment</h1>
          <ew-payment-method-list
          ></ew-payment-method-list>
        </ew-mat-stepper-custom-step> -->

    <ew-mat-stepper-custom-step>
      <h1 class="mb-3">How would like to use your Wallet?</h1>
      <div class="gt-xs:flex w-full mt-2">
        <div class="gt-xs:w-1/3 grid grid-cols-1 gap-4 scroll">
          <ew-currency-money
            [class.d-none]="currencySelected && currencySelected != item"
            [item]="item"
            (click)="
              currencySelected =
                currencySelected && currencySelected == item ? null : item
            "
            *ngFor="let item of currencies | slice: 0 : 4"></ew-currency-money>
        </div>
        <div
          class="gt-xs:w-2/3 flex items-center xs:mt-4"
          *ngIf="currencySelected">
          <div class="w-full">
            <ew-price-information [price]="315074.15"></ew-price-information>
            <div class="text-center p-5">
              <div class="">Wallet balance:</div>
              <div class="text-warn font-medium text-lg">$5,200 CAD</div>
            </div>
          </div>
        </div>
      </div>
    </ew-mat-stepper-custom-step>

    <!-- <ew-mat-stepper-custom-step>
          <h1 class="mb-3">Review and confirm payment information</h1>
          <ew-payment-form
          ></ew-payment-form>
        </ew-mat-stepper-custom-step> -->

    <ew-mat-stepper-custom-step>
      <img class="w-3/5 m-auto fly" src="assets/fly.svg" alt="" />
    </ew-mat-stepper-custom-step>

    <ew-mat-stepper-custom-step>
      <h1 class="mb-3">We are sending you your money safely</h1>
      <div class="p-20 xs:px-0">
        <ew-price-information
          [provider]="provider"
          [progress]="true"
          [price]="315074.15"></ew-price-information>

        <div class="w-full text-center my-10">
          <button
            class="rounded-lg xs:w-full w-80"
            mat-flat-button
            color="primary">
            Download proof of payment
          </button>
        </div>
      </div>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
